// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"nct0HbrQ","rightWrapper":"nzbXn6Zf","tooltipTitleLabel":"RnVyy7OV","categoryLabel":"aQErqkIB"};